import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_navbar = _resolveComponent("navbar")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", {
    id: "app",
    class: _normalizeClass({ container: !_ctx.isFullBleed, 'memories-route': _ctx.isMemoriesRoute })
  }, [
    _createElementVNode("div", {
      style: _normalizeStyle(_ctx.isFullBleed ? { padding: '1rem 1.5rem 0' } : {})
    }, [
      _createVNode(_component_navbar)
    ], 4),
    _createVNode(_component_router_view)
  ], 2))
}